module.exports = __webpack_public_path__ + "static/media/ConnectImage.29c7a2aa.png";